import employee from "../views/employee/index.vue";
import employee_create from "../views/employee/create.vue";
import employee_edit from "../views/employee/edit.vue";
import employee_detail from "../views/employee/detail.vue";
import employee_import from "../views/employee/import.vue";

const routes = [
  {
    path: "/employee",
    name: "employee",
    component: employee,
    meta: { authOnly: true }
  },
  {
    path: "/employee/create",
    name: "employee_create",
    component: employee_create,
    meta: { authOnly: true }
  },
  {
    path: "/employee/edit/:uuid",
    name: "employee_edit",
    component: employee_edit,
    meta: { authOnly: true }
  },
  {
    path: "/employee/detail/:uuid",
    name: "employee_detail",
    component: employee_detail,
    meta: { authOnly: true }
  },
  {
    path: "/employee/import",
    name: "employee_import",
    component: employee_import,
    meta: { authOnly: true }
  }
];

export default routes;
